import React from 'react'
import { AlertTriangle, DollarSign, Hash, Search } from 'react-feather';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { startloadListEarnings } from '../../../../app/store/reportes/thunks';
import { Table_2 } from '../../../utils/Table_2';

export const ProfistCustomer = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });
    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;
    const { isLoading, status_report, earnings } = useSelector(state => state.reportes);

    const searchOrdenes = (data) => {
        console.log(data);
        dispatch(startloadListEarnings(data.fechaInicial, data.fechaFinal))
    }

    const dataU = [...earnings];
    const columnsType = [
        {
            header: 'ID',
            dataIndex: 'CLIENTE_ID',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => (
                <>
                    <button type="button" className="btn btn-link"
                    // data-bs-toggle="modal" data-bs-target="#detailFolio"
                    // onClick={() => loadFolio(value)}
                    >{value}</button>
                </>
            ),

        },
        {
            header: 'CLIENTE',
            dataIndex: 'NOMBRE',
            classHeader: 'text-start',
            classRow: 'text-start',

        },
        {
            header: 'CEL.',
            dataIndex: 'CELULAR',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'EMAIL',
            dataIndex: 'EMAIL',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: '# ORDENES',
            dataIndex: 'CONTEO_ORDENES',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'GANACIAS OR.',
            dataIndex: 'GANANCIA_ORDENES',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => ( Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)) ,
        },

        {
            header: '# VENTAS',
            dataIndex: 'CONTEO_VENTAS',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'GANANCIAS VEN.',
            dataIndex: 'GANANCIA_VENTAS',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => ( Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)) ,
        },
        {
            header: 'GANANCIAS TOTAL',
            dataIndex: 'GANANCIAS_TOTALES',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => ( Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)) ,
        }
    ];

    let ganancias = 0; let countOrdenes = 0; let countVentas = 0;

    earnings?.forEach(item => {
        ganancias = ganancias + Number(item.GANANCIAS_TOTALES);     
    });


    // console.log(ganancias);
    // console.log(countOrdenes);

    return (
        <div className="card">
            <div className="card-header border-bottom">
                <h4 className="fw-bold text-black">Ganacias por clientes</h4>
            </div>
            <div className="card-body">
                <form className='row' onSubmit={handleSubmit(searchOrdenes)} >
                    <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                        <label className="form-label">Fecha de Inicio:</label>
                        <input type="date" className="form-control" {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                        {
                            errors.fechaInicial &&
                            <div className='text-left-5 mt-2'>
                                <AlertTriangle size="18" color="#dc3545" />
                                <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                            </div>
                        }
                    </div>
                    <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2  ">
                        <label className="form-label">Fecha de Termino:</label>
                        <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal")} />
                    </div>

                    <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-1">
                        <div className="mb-3 mt-4">
                            <button type="submit" className="btn btn-outline-secondary">
                                <Search size="20" /> Buscar
                            </button>
                        </div>
                    </div>
                </form>
                <hr className='my-0' />
                <h5 className='fw-bold mt-4 mb-2'>Resultados</h5>

                <div className='row'>
                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <div className="card border">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col mt-0">
                                        <h5 className="card-title">Total de Ganancias <br /><span className='small'>(En el periodo)</span></h5>
                                    </div>
                                    <div className="col-auto">
                                        <div className="stat text-primary">
                                            <DollarSign size={22} />
                                        </div>
                                    </div>
                                </div>
                                <h1 className="mt-1 mb-1">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ganancias)}</h1>
                            </div>
                        </div>
                    </div>

                   
                </div>
                <Table_2 typeTable={3} columns={columnsType} data={dataU} msg={'En espera para mostrar datos'} />
            </div>
        </div>
    )
}
